import React, { useEffect, useState } from 'react';
import ContestService from "../../services/Contest";

import './styles.css';
import { Link } from "react-router-dom";

export default function Contest() {
    const [categoria, setCategoria] = useState("Vídeos");
    const [concursos, setConcursos] = useState([]);

    useEffect(() => {
        ContestService.readByCategory(categoria).then((response) => { setConcursos(response) })
            .catch(err => {
                alert('Erro ao processar requisição')
                console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
            })
    }, [categoria]);

    return (
        <div id="contest-section" className="main-contest">
            <div className="header-contest">
                <h1 className="title-contest">Concurso</h1>
                <h2 className="sub-title-contest">Aqui estão listados alguns dos trabalhos que já foram submetidos.</h2>
                <select className="select-contest" onChange={e => { setCategoria(e.target.value) }}>
                    <option value={'Ações ambientais e/ou sociais (vídeos)'}>Ações ambientais e/ou sociais (vídeos)</option>
                    <option value={'Fotografia'}>Fotografia</option>
                    <option value={'Música / Paródia'}>Música / Paródia</option>
                    <option value={'Poemas / Cordel'}>Poemas / Cordel</option>
                    <option value={'Charges'}>Charges</option>
                    <option value={'Tirinhas'}>Tirinhas</option>
                    <option value={'Desenho'}>Desenho</option>
                </select>
            </div>
            <ul className="cards-contest">
                {concursos.map(concurso => (
                    <li key={concurso.id} className="card-contest">
                        <p className="card-contest-title">Título:</p>
                        <h3>{concurso.title}</h3>
                        <p className="card-contest-title">Categoria:</p>
                        <h3>{concurso.category}</h3>
                        <Link to={'/concurso/' + concurso.id}><p className="card-contest-button">mais</p></Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
